package com.neurobs.ccabserver.translation.components.translationreplacement.components

import com.neurobs.ccabserver.translation.states.{TranslationReplacement, TranslationSubSearchStateGenerator}
import com.neurobs.react.StyleUtil
import org.scalajs.dom
import org.scalajs.dom.console
import slinky.core.{FunctionalComponent, SyntheticEvent, TagElement}
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.React
import slinky.web.SyntheticUIEvent
import slinky.web.html._

import scala.scalajs.js

@react
object MatchingTranslationsView {
  case class Props(matchingTranslations: Seq[TranslationReplacement])
  val component = FunctionalComponent[Props] { props =>

    val divRef = React.createRef[dom.html.Div]

    def divStyle = Seq[(String, js.Any)](
//      ("overflowY", "scroll"), ("maxHeight", "200px"),
      ("marginTop", "10px"), ("paddingTop", "10px"))

    div(
      className := "ui fluid basic segment",
      style := StyleUtil.makeStyle(divStyle:_*),
      ref := divRef,
    )(
      props.matchingTranslations.map(translation => TranslationView(translation))
    )
  }
}

@react
object TranslationView {
  case class Props(translation: TranslationReplacement)
  val component = FunctionalComponent[Props] { props =>

    val translationSubSearchState = TranslationSubSearchStateGenerator.accessState

    def isFocused = translationSubSearchState.focusedTranslationIdState.value == props.translation.dbId

    def segmentStyleAttrs = {
      var attrs = Seq[(String, js.Any)](("cursor", "pointer"), ("color", "black"))
      if (isFocused) {
        attrs = attrs ++ Seq[(String, js.Any)](("fontWeight", "bold"))
      }
      attrs
    }
    def handleClick = (e: SyntheticEvent[TagElement#RefType, dom.Event]) => {
      translationSubSearchState.focusedTranslationIdState.setValue(props.translation.dbId)
    }

    div(
      className := "ui segment",
      onClick := handleClick,
      style := StyleUtil.makeStyle(segmentStyleAttrs:_*)
    )(
      props.translation.translationData.text
    )
  }

}
